import React from 'react';
import SEO from './SEO';
import JivanYatraSection from './JivanYatraSection';
import { Users, Star, Building, Heart, Briefcase, Calendar, MapPin } from 'lucide-react';

const aboutContent = {
  name: 'संजय ह. परदेशी',
  birthDate: '10 नवंबर 1965',
  birthPlace: 'पुणे, महाराष्ट्र',
  // profession: 'मेकैनिकल इंजीनियर',
};

const AboutPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-orange-50 to-yellow-50 flex flex-col">
    <SEO 
      title="परिचय - संजय ह. परदेशी"
      description="समाज और राष्ट्र-धर्म सेवा को समर्पित श्री. संजय हरिसिंग परदेशी का विस्तृत परिचय। स्वदेशी आंदोलन, राष्ट्रीय नीतियों और सामाजिक सुधार के क्षेत्र में उनके योगदान की जानकारी।"
      keywords="संजय परदेशी, स्वदेशी आंदोलन, राष्ट्रीय नीति, सामाजिक सुधार, भारत कैसे बदले, सीधी सोच सीधी बात"
      url="/about"
    />
    
    {/* Hero Section */}
    <section className="w-full flex justify-center items-center py-8 px-4 bg-transparent animate-fade-in">
      <div className="w-full max-w-6xl flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
        {/* Profile Image */}
        <div className="flex-shrink-0 flex flex-col justify-center items-center">
          <div className="w-56 h-56 md:w-72 md:h-72 rounded-full overflow-hidden flex items-center justify-center border-4 border-orange-200 bg-white shadow-2xl mb-4">
            <img
              src="/images/scsb-1.jpeg"
              alt="संजय परदेशी"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-extrabold text-orange-700 tracking-tight mb-2">{aboutContent.name}</h1>
            <div className="h-1 w-24 bg-orange-500 rounded mx-auto mb-4" />
            <div className="text-lg text-gray-600 space-y-1">
              <p className="flex items-center justify-center gap-2"><Calendar className="w-4 h-4" /> जन्म: {aboutContent.birthDate}</p>
              <p className="flex items-center justify-center gap-2"><MapPin className="w-4 h-4" /> {aboutContent.birthPlace}</p>
              {/* <p className="flex items-center justify-center gap-2"><Briefcase className="w-4 h-4" /> {aboutContent.profession}</p> */}
            </div>
          </div>
        </div>
        
        {/* Main Introduction */}
        <div className="flex-1 max-w-4xl">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 shadow-md border border-orange-100">
            <h2 className="text-2xl md:text-3xl font-bold text-orange-700 mb-6 flex items-center gap-3">
              <Star className="w-8 h-8 text-orange-500" />
              परिचय
            </h2>
            <div className="text-gray-800 text-lg leading-relaxed space-y-6">
              <p className="text-xl font-semibold text-orange-800 border-l-4 border-orange-500 pl-4 bg-orange-50 py-3 rounded-r-lg">
                समाज और राष्ट्र-धर्म सेवा को समर्पित <strong>श्री. संजय हरिसिंग परदेशी</strong> देश की समस्याओं और सरोकारों पर निरंतर चिंतन करते रहते हैं और समाधान के लिए भी प्रयासरत रहते हैं।
              </p>
              <p>
                इनका मानना है कि देश में शासन-प्रशासन और लोगों के अनुशासन के लिए आवश्यक है कि भारत की न्याय और शिक्षा व्यवस्था तथा विचारधारा में आमूलचूल परिवर्तन हों।
              </p>
              <p>
                पेशे से <strong>मेकैनिकल इंजीनियर</strong>, श्री. संजय ह. परदेशी इस निमित्त <span className="text-orange-600 font-semibold">'भारत कैसे बदले', 'सीधी सोच, सीधी बात', 'सोच बदलो, देश बदलेगा'</span> जैसी विचारधारा एवं नीतियों के आरंभकर्ता हैं।
              </p>
              <div className="bg-gradient-to-r from-orange-100 to-yellow-100 p-6 rounded-xl border-l-4 border-orange-500">
                <p className="font-semibold text-gray-800">
                  वह कहते हैं कि जनसंख्या के दबाव और संसदीय लोकतंत्र में व्याप्त कुछ दोषों, कमियों की वजह से जनता में स्वानुशासन, नागरिक दायित्व और कानून के प्रति सम्मान का अभाव है। जब तक न्याय और शिक्षा व्यवस्था में आधारभूत परिवर्तन नहीं होंगे, तब तक इन समस्याओं का समाधान नहीं हो सकता।
                </p>
              </div>
              <p className="text-lg font-medium text-orange-700">
                एक प्रगतिशील राष्ट्रवादी चिंतक के रूप में संजय ह. परदेशी जनहित, समाजहित, राष्ट्रहित और राष्ट्र-धर्म को लेकर सक्रिय, सचेत, चिंतनशील रहते हैं।
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* राजीवभाई दीक्षित के साथ यात्रा */}
    <section className="w-full py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl p-8 shadow-md border border-orange-100">
          <h2 className="text-3xl font-bold text-orange-700 mb-8 flex items-center gap-3">
            <Heart className="w-8 h-8 text-red-500" />
            राजीवभाई दीक्षित के साथ स्वदेशी यात्रा
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="bg-orange-50 p-6 rounded-xl border-l-4 border-orange-500">
                <h3 className="text-xl font-bold text-orange-700 mb-3">प्रथम परिचय (15 अक्टूबर 1998)</h3>
                <p className="text-gray-700">
                  रमणबाग हायस्कूल, पुणे में दशहरे के दिन सुबह 9.30 से 12 बजे के दौरान स्वदेशी पर पहला भाषण सुनते हुए राजीवभाई दीक्षितजी से परिचय हुआ।
                </p>
              </div>
              
              <div className="bg-yellow-50 p-6 rounded-xl border-l-4 border-yellow-500">
                <h3 className="text-xl font-bold text-yellow-700 mb-3">तत्काल प्रभाव</h3>
                <p className="text-gray-700">
                  राजीवभाई के स्वदेशी के कैसेट्स क्रमांक 1 से 10 एक ही दिन-रात में सुबह के 4 बजे तक सुने गए। वहीं से जीवन में बहुत परिवर्तन आया।
                </p>
              </div>
              
              <div className="bg-green-50 p-6 rounded-xl border-l-4 border-green-500">
                <h3 className="text-xl font-bold text-green-700 mb-3">निरंतर संपर्क</h3>
                <p className="text-gray-700">
                  बाद में राजीवभाई से निरंतर भेंट होती रही। वे सर्वप्रथम 1999 में इनके घर आये और बाद में कई बार आये।
                </p>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="bg-blue-50 p-6 rounded-xl border-l-4 border-blue-500">
                <h3 className="text-xl font-bold text-blue-700 mb-3">स्वदेशी जीवनशैली</h3>
                <p className="text-gray-700">
                  स्वदेशी वस्तु, स्वदेशी जीवनशैली अपनाना शुरू हुआ और 1999 से आज तक निरंतर वह जारी है।
                </p>
              </div>
              
              <div className="bg-purple-50 p-6 rounded-xl border-l-4 border-purple-500">
                <h3 className="text-xl font-bold text-purple-700 mb-3">अध्ययन की शुरुआत</h3>
                <p className="text-gray-700">
                  देश, इतिहास पर आधारित पुस्तकें खरीदना और पढ़ना शुरू हुआ। आज घर में छोटी सी लाइब्रेरी है जहाँ 700 से ज्यादा पुस्तकें हैं, जिसमें 95% देश, इतिहास हिंदू धर्म पर आधारित है।
                </p>
              </div>
              
              <div className="bg-indigo-50 p-6 rounded-xl border-l-4 border-indigo-500">
                <h3 className="text-xl font-bold text-indigo-700 mb-3">सक्रिय कार्य</h3>
                <p className="text-gray-700">
                  राजीवभाई के साथ महाराष्ट्र में घूमना शुरू हुआ। कई गाँवों में गए, भाषण आयोजित किए और कई रैलियाँ कीं। स्वयं का कारोबार संभालते हुए स्वदेशी का आवाहन शुरू हुआ।
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-8 bg-gradient-to-r from-red-50 to-orange-50 p-6 rounded-xl border border-red-200">
            <h3 className="text-xl font-bold text-red-700 mb-3">राजीवभाई का योगदान</h3>
            <p className="text-gray-700 mb-4">
              राजीवभाई एक बुद्धिवादी प्रखर देशभक्त व्यक्ति थे जो भारत के लिए लगातार 20/22 साल तक काम करते रहे। पूरे भारत में दिन-रात प्रवास करते हुए राष्ट्रबंधु श्री. राजीवभाई दीक्षितजी ने 10,000 से ज्यादा अलग अलग विषयों पर व्याख्यान दिए। इन ज्वलंत व्याख्यानों से लाखों लोगों को देश के लिए काम करने की प्रेरणा मिली।
            </p>
            <div className="bg-white p-4 rounded-lg border border-red-200">
              <h4 className="font-bold text-red-700 mb-2">HOW TO REVIVE INDIA..? पर कार्य</h4>
              <p className="text-gray-700 text-lg">
                इसी दौरान श्री. संजय ह. परदेशी जी ने राजीवभाई के साथ 'HOW TO REVIVE INDIA..?' 'भारत कैसे बदले..?' इस पर काम करना शुरू किया। राजीवभाई मानते थे कि स्वदेशी और मूलभूत बदल योजना विभाग (मूबयो) की सहायता से भारत में बदलाव हो सकता है।
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* महत्वपूर्ण व्यक्तित्वों से भेंट */}
    <section className="w-full py-12 px-4 bg-gradient-to-r from-orange-50 to-yellow-50">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl p-8 shadow-md border border-orange-100">
          <h2 className="text-3xl font-bold text-orange-700 mb-8 flex items-center gap-3">
            <Users className="w-8 h-8 text-blue-500" />
            महत्वपूर्ण व्यक्तित्वों से भेंट और चर्चा
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl border border-orange-200">
              <h3 className="text-lg font-bold text-orange-700 mb-3">पुरुषोत्तम नागेश ओक (पु. ना. ओक)</h3>
              <p className="text-sm text-gray-700">
                ज्ञानी इतिहासकार जिन्होंने सिद्ध किया कि लाल किला (लाल कोट), ताजमहल (तेजोमहालय), कुतुबमीनार (विष्णुस्तंभ) आदि सभी वास्तुरचनाएँ भारतीय हिंदू राजाओं ने बनवाई हैं।
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200">
              <h3 className="text-lg font-bold text-blue-700 mb-3">प्रोफेसर धर्मपालजी</h3>
              <p className="text-sm text-gray-700">
                ज्ञानी हिंदी भाषिक इतिहासकार के साथ विस्तृत चर्चा और मार्गदर्शन।
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl border border-green-200">
              <h3 className="text-lg font-bold text-green-700 mb-3">स्वामी रामदेवजी</h3>
              <p className="text-sm text-gray-700">
                जिनके साथ मिलकर 'भारत स्वाभिमान' स्थापना हुआ। 'स्वदेशी' के लिए बहुत बड़ा मंच मिला।
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl border border-purple-200">
              <h3 className="text-lg font-bold text-purple-700 mb-3">पंडित रविशंकरजी</h3>
              <p className="text-sm text-gray-700">
                आध्यात्मिक मार्गदर्शन और राष्ट्रीय चिंतन में योगदान।
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-xl border border-red-200">
              <h3 className="text-lg font-bold text-red-700 mb-3">राजनैतिक नेता</h3>
              <p className="text-sm text-gray-700">
                सन 2000 से 2010 तक कांग्रेस और बीजेपी के कुछ मान्यवर नेताओं के साथ भेट और चर्चा।
              </p>
            </div>
            
            <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 p-6 rounded-xl border border-yellow-200">
              <h3 className="text-lg font-bold text-yellow-700 mb-3">स्वदेशी कार्यकर्ता</h3>
              <p className="text-sm text-gray-700">
                भारतभर के कार्यकर्ताओं ने कोल्ड्रिंक्स पीना छोड़ दिया, जंक फूड खाना बहुत कम कर दिया।
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* व्यावसायिक यात्रा */}
    <section className="w-full py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl p-8 shadow-md border border-orange-100">
          <h2 className="text-3xl font-bold text-orange-700 mb-8 flex items-center gap-3">
            <Building className="w-8 h-8 text-gray-600" />
            व्यावसायिक यात्रा और देश कार्य
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="bg-green-50 p-6 rounded-xl border-l-4 border-green-500">
                <h3 className="text-xl font-bold text-green-700 mb-3">फैक्टरी की स्थापना (2005)</h3>
                <p className="text-gray-700">
                  वर्ष 2005 में पुणे में खुद की फैक्टरी शुरू की, जहाँ सन 2017 तक 100 से ज्यादा लोग काम करते थे और जहाँ पर 'इंडस्ट्रियल क्रेन्स' का निर्माण होता था। साथ में सिविल कन्स्ट्रक्शन का काम भी शुरू था।
                </p>
              </div>
              
              <div className="bg-orange-50 p-6 rounded-xl border-l-4 border-orange-500">
                <h3 className="text-xl font-bold text-orange-700 mb-3">सुवर्ण मध्य (2018)</h3>
                <p className="text-gray-700">
                स्वदेशी और हिंदुत्व इन दो धर्मकार्य के लिए वे 2018 में अपनी फैक्ट्री से मुक्त हुए और अब बिजनेस सीमित करके अधिक समय धर्मकार्य को दे रहे हैं।
                </p>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-8 rounded-xl border border-blue-200">
              <h3 className="text-2xl font-bold text-blue-700 mb-6">धर्मकार्य के लिए समर्पण</h3>
              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                  <span className="text-gray-700">100+ कर्मचारियों की फैक्टरी का त्याग</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  <span className="text-gray-700">स्वदेशी आंदोलन को पूर्णकालिक समर्पण</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-orange-500 rounded-full"></div>
                  <span className="text-gray-700">हिंदुत्व और राष्ट्रधर्म को प्राथमिकता</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-3 h-3 bg-purple-500 rounded-full"></div>
                  <span className="text-gray-700">व्यक्तिगत लाभ से राष्ट्रहित को प्राथमिकता</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Timeline Section (JivanYatraSection) */}
    <div className="flex-1 animate-fade-in">
      <JivanYatraSection />
    </div>
  </div>
);

export default AboutPage;